import {Reducers} from './dataEnum';

export const SHOW_RECOVERY_LOADING = `${Reducers.LOADING_STORE}/SHOW_RECOVERY_LOADING`;

export const SHOW_LOADING = `${Reducers.LOADING_STORE}/SHOW_LOADING`;
export const UPDATE_LOADING = `${Reducers.LOADING_STORE}/UPDATE_LOADING`;
export const UPDATE_LOADING_TEXT = `${Reducers.LOADING_STORE}/UPDATE_LOADING_TEXT`;
